<template>
  <div class="modal" v-bind:class="{ 'is-active': showmodal }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <div class="level container">
          <div></div>
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">{{ task.date | date() }}</p>
              <h1 class="modal-card-title">
                {{ task.empresaproject ? task.empresaproject.name : "" }} -
                {{ task.project ? task.project.name : "" }}
              </h1>
              <div
                class="level-item has-text-centered"
                @mouseover="hover = true"
                @mouseleave="hover = false"
              >
                <div
                  v-for="(item, index) in task.tags"
                  :key="index"
                  class="button is-link is-small is-static"
                >
                  <div class="level-item">
                    <span>{{ item }}</span>
                    <span v-if="hover == true" class="icon is-small">
                      <i
                        @click="borrarelementoarray(task.tags, item)"
                        class="delete is-small"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="level">
            <button
              class="delete is-large"
              aria-label="close"
              @click="closeModal"
            ></button>
          </div>
        </div>
      </header>

      <section class="modal-card-body">
        <div class="field" v-if="task._id">
          <label class="label">Orden</label>
          <div class="control">
            <input
              v-model="task.orden"
              class="input"
              type="text"
              placeholder="Orden"
            />
          </div>
        </div>
        <div class="field is-grouped">
          <span class="control is-expanded">
            <label class="label">Titulo</label>
            <input
              class="input field"
              type="text"
              placeholder="Titulo descriptivo de la tarea"
              v-model="task.title"
            />
          </span>
          <span class="control">
            <label class="label">Tags</label>
            <div class="dropdown is-right is-hoverable">
              <button class="button is-outlined is-link">
                <i class="material-icons">playlist_add</i>
              </button>

              <div class="dropdown-menu" role="menu">
                <div class="dropdown-content">
                  <div
                    v-for="(item, index) in tagsnousados"
                    :key="index"
                    class="dropdown-item"
                  >
                    <p class="hand" @click="creatag(item)">{{ item }}</p>
                  </div>
                  <hr class="dropdown-divider" />
                  <div class="dropdown-item">
                    <div class="control">
                      <input
                        class="input is-info"
                        type="text"
                        placeholder="otro.."
                        v-model="tagInput"
                        @keyup.enter="creatag()"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>

        <div class="field">
          <label class="label">Descripción</label>
          <textarea
            v-model="task.descripcion"
            class="textarea"
            placeholder="Pequeña descripción de la tarea"
            rows="4"
          ></textarea>
        </div>

        <div class="field">
          <label class="label"
            >Ticket
            <small style="font-size: 11px" class="has-text-grey"
              >**Opcional</small
            >
          </label>
          <div class="control">
            <div class="select is-fullwidth">
              <select v-model="task.ticket">
                <option
                  v-for="(item1, index1) in tickets"
                  :key="index1"
                  :value="item1._id"
                >
                  {{ item1.empresa.nombre }} - {{ item1.title }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label"
                >Responsable
                <small style="font-size: 11px" class="has-text-grey"
                  >**Opcional</small
                >
              </label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="task.assignedto">
                    <option
                      v-for="(item2, index2) in users"
                      :key="index2"
                      :value="item2._id"
                    >
                      {{ item2.displayName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Estado </label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="task.status">
                    <option
                      v-for="(item3, index3) in estados"
                      :key="index3"
                      :value="item3"
                    >
                      {{ item3 }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">Prioridad</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="task.priority">
                    <option
                      v-for="(item4, index4) in prioridades"
                      :key="index4"
                      :value="item4"
                    >
                      {{ item4 }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="columns"
          v-if="status === 'Proceso' || status === 'Revision'"
        >
          <div class="column">
            <div class="field">
              <label class="label">Horas trabajadas</label>
              <div class="control">
                <input
                  v-model="task.horas"
                  class="input"
                  type="number"
                  placeholder="Horas dedicadas a la tarea"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <div class="file is-info">
                <label class="file-label">
                  <input
                    class="file-input"
                    type="file"
                    @change="onFileChange"
                    name="resume"
                  />
                  <span class="file-cta">
                    <span class="file-icon">
                      <i class="material-icons">cloud_upload</i>
                    </span>
                    <span class="file-label">&nbsp; Adjuntar archivo</span>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <progress
              v-show="avaceupload > 0"
              class="progress is-info is-small"
              :value="avaceupload"
              max="100"
            ></progress>
          </div>
          <div class="column is-12">
            <ul>
              <li v-for="(item, index) in task.attach" :key="index">
                <a :href="item.url" target="blank">{{ item.name }}</a>
                <span
                  class="material-icons has-text-danger hand"
                  @click="deleteAttachedFile(index, item)"
                >
                  delete_forever
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-primary" @click="savemodal">
          {{ task._id ? "Guardar" : "Crear" }}
        </button>
        <button class="button" @click="closeModal">Cancelar</button>
        <button v-if="task._id" class="button is-danger" @click="deleteTask">
          Eliminar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
// import { mapState } from "vuex";

export default {
  data() {
    return {
      avaceupload: 0,
      hover: false,
      tagInput: "",
      estados: ["Pendiente", "Proceso", "Revision", "Resuelta"],
      prioridades: ["Baja", "Media", "Alta"],

      task: {
        orden: null,
        _id: null,
        date: null,
        title: null,
        descripcion: null,
        status: "Pendiente",
        tags: [],
        priority: "Baja",
        dateResolve: null,
        assignedto: null,
        ticket: null,
        empresaproject: null,
        project: null,
        horas: null,
        attach: [],
      },
      users: [],
      projects: [],
    };
  },
  props: {
    modaldata: Object,
    showmodal: Boolean,
    tags: Array,
    tickets: Array,
    status: String,
  },
  computed: {
    fecha() {
      var date;
      if (this.modaldata.Fecha) {
        date = this.modaldata.Fecha;
      } else {
        date = Date(Date.now()).toLocaleString().slice(0, 15);
      }
      return date;
    },
    titulo() {
      var titulo;
      if (this.modaldata.IdTicket) {
        titulo = "Solicitud Numero " + this.modaldata.IdTicket;
      } else {
        titulo = "Nueva solicitud para *NombreDelCliente*";
      }
      return titulo;
    },
    tagsnousados() {
      var todoslostags;
      let unique;
      if (this.modaldata.tags && this.tags) {
        todoslostags = this.tags.concat(this.modaldata.tags);
        unique = [...new Set(todoslostags)];
        this.modaldata.tags.forEach((element) => {
          this.borrarelementoarray(unique, element);
          this.borrarelementoarray(unique, "__ob__");
        });
      }

      return unique;
    },
  },
  methods: {
    deleteAttachedFile(index, status) {
      try {
        this.task.attach.splice(index, 1);
      } catch (err) {
        console.log(err);
      }
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.attachproject(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              const d = {
                name: `${file.name}`,
                url,
              };
              _this.task.attach.push(d);
              _this.avaceupload = 0;
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
    deleteTask() {
      this.$emit("deletetask", this.task);
    },
    savemodal() {
      if (!this.task.title) {
        this.$store.dispatch("notify", {
          message: "Debe indicar un título para la tarea.",
          type: "is-danger",
          position: "top-center",
        });
        return false;
      }
      if (!this.task.descripcion) {
        this.$store.dispatch("notify", {
          message: "Debe indicar una pequeña descripción de la tarea.",
          type: "is-danger",
          position: "top-center",
        });
        return false;
      }
      if (this.status === "Proceso" || this.status === "Revision") {
        if (this.status !== this.task.status) {
          if (!this.task.horas) {
            this.$store.dispatch("notify", {
              message: "Debe indicar las horas dedicadas a esta tarea.",
              type: "is-danger",
              position: "top-center",
            });
            return false;
          }
        }
      }
      this.$emit("savemodal", this.task);
    },
    async findUserTask() {
      try {
        const result = await apiServices.get(`/userstask`);
        if (result.data) {
          this.users = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    closeModal() {
      // this.showmodal = false;
      this.$emit("closemodal");
    },
    creatag(tag) {
      if (!tag) {
        tag = this.tagInput;
        this.tagInput = "";
      }
      if (!this.task.tags.includes(tag)) {
        this.task.tags.push(tag);
      }
    },
    borrarelementoarray(array, elemento) {
      const index = array.indexOf(elemento);
      if (index > -1) {
        array.splice(index, 1);
      }
    },
    pushprop(propiedadnueva, valor) {
      this.$set(this.modaldata, propiedadnueva, valor);
    },
  },
  watch: {
    showmodal(nv, ov) {
      if (nv) {
        this.task = JSON.parse(JSON.stringify(this.modaldata));
        this.task.date = Date(Date.now()).toLocaleString().slice(0, 15);
      }
    },
  },
  created() {
    this.findUserTask();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/Modalticket.vue